import React, { FC, useMemo } from 'react';

interface Props {
  selectedOptions: string[];
  placeholder?: string;
  dataTestId?: string;
}

export const POSMultiselectTags: FC<Props> = ({
  selectedOptions,
  placeholder,
  dataTestId,
}) => {
  const isAllSelected = selectedOptions.includes('All');

  const tagArray = useMemo(
    () =>
      isAllSelected ? selectedOptions.slice(1, 2) : selectedOptions.slice(0, 2),
    [selectedOptions, isAllSelected]
  );

  if (isAllSelected) {
    return (
      <div
        className="p-os-multi-tags"
        data-testid={!!dataTestId ? dataTestId : 'p-os-multi-tags'}
      >
        <div className="tags">
          <span className="p-os-multi-tag-label">All items selected</span>
        </div>
      </div>
    );
  }

  if ((selectedOptions?.length || 0) === 0) {
    return (
      <div
        className="p-os-multi-tags"
        data-testid={!!dataTestId ? dataTestId : 'p-os-multi-tags'}
      >
        <div className="tags">
          <span className="p-os-multi-tag-emptylabel">
            {placeholder || 'choose an option...'}
          </span>
        </div>
      </div>
    );
  }

  return (
    <div
      className="p-os-multi-tags"
      data-testid={!!dataTestId ? dataTestId : 'p-os-multi-tags'}
    >
      <div className="tags">
        {tagArray.map((el: string) => {
          return (
            <span className="p-os-multi-tag-label" key={el}>
              {el}
            </span>
          );
        })}

        {selectedOptions.length > 2 && (
          <span className="p-os-multi-tag-label">
            {`+ ${selectedOptions.length - 2}`}
          </span>
        )}
      </div>
    </div>
  );
};
